var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D5D5D5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 6.99C20.61 6.44 20.06 6.12 19.51 6.24C17.13 6.77 14.48 7 12 7C9.52002 7 6.87002 6.77 4.49002 6.24C3.94002 6.12 3.39002 6.44 3.25002 6.99C3.11002 7.55 3.45002 8.12 4.00002 8.25C5.61002 8.61 7.35002 8.86 9.00002 9V21C9.00002 21.55 9.45002 22 10 22C10.55 22 11 21.55 11 21V16H13V21C13 21.55 13.45 22 14 22C14.55 22 15 21.55 15 21V9C16.65 8.86 18.39 8.61 19.99 8.25C20.55 8.12 20.89 7.55 20.75 6.99ZM12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.4a20e74dae11c3bb33be581aec91096b.svg";
export { ForwardRef as ReactComponent };